<template>
  <div class='dean-form-row'>
    <div class='row partnerSelect'>
      <div class='small-6 medium-6 large-6 hd-6 columns'>
        <p class='input-label'> {{ label }} <span style="color:red">{{requiredField ? '*' : ''}}</span></p>
      </div>
      <div class='small-6 medium-6 large-6 hd-6 columns'>
        <div class="multiselect-wrapper">
          <multiselect :placeholder="placeholderWithRequired"
                       :close-on-select="closeOnSelect"
                       :show-labels="false"
                       :multiple="multiple"
                       :id='id' label="label"
                       :options='options'
                       :value='value'
                       :class="validationClass"
                       :disabled="disabled"
                       @select='propagateSelect'
                       @remove='propagateRemove'></multiselect>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
    // VUE
    import { Vue, Component, Prop } from 'vue-property-decorator';
    import Multiselect from 'vue-multiselect';

    // COMPONENTS
    @Component({
        components: {
            Multiselect,
        },
    })

    export default class deanMultiSelectFormRow extends Vue {
      @Prop() private options?: any[];
      @Prop() private value?: any;
      @Prop() private placeholder?: string;
      @Prop() private label?: string;
      @Prop() private id?: string;
      @Prop() private multiple?: boolean;
      @Prop({default: false}) private closeOnSelect?: boolean;
      @Prop({default: false}) protected warning!: boolean;
      @Prop({default: false}) protected requiredField!: boolean;
      @Prop({default: false}) disabled?: boolean;

      get validationClass() {
        return this.warning ? 'warning' : '';
      }

      public propagateSelect(input: any) {
        this.$emit('select', input)
      }

      public propagateRemove(input: any) {
        this.$emit('remove', input)
      }

      get placeholderWithRequired() {
        let placeholder = this.placeholder;
        return this.requiredField ? placeholder + ' *' : placeholder;
      }
    }
</script>

<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
  @import '~vue-multiselect/dist/vue-multiselect.min.css';

  p.input-label {
    padding-left: 20px;
    padding-top: 17px;
    padding-bottom: 17px;
  }

  .multiselect-wrapper {
    padding: 5px 10px 5px 10px;
  }

  :deep .multiselect.warning {
    border: 1px solid red;
    border-radius: 6px;
  }

  :deep .multiselect__tag {
    background: var(--color-secondary, $color-secondary);
    :deep .multiselect__tag-icon:after {
      color: white;
    }
  }

  :deep .multiselect__option--selected {
    background: var(--color-secondary, $color-secondary);
    color: white;
  }

  :deep .multiselect__option--highlight {
    background: var(--color-primary, $color-primary);
  }

  :deep .multiselect__option--highlight:after {
    background: none;
  }

  :deep .multiselect__tag-icon:focus, :deep .multiselect__tag-icon:hover {
    background: var(--color-primary, $color-primary);
  }
</style>
